import { render, staticRenderFns } from "./CallToActionsAdd.vue?vue&type=template&id=4aa7712d"
import script from "./CallToActionsAdd.vue?vue&type=script&lang=js"
export * from "./CallToActionsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports